import PrivacyPolicy from './component'

export default PrivacyPolicy
